import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9 6V5C9 3.56225 7.65685 2 6 2C4.34315 2 3 3.56225 3 5C3 6.61102 3 6.27769 3 6H9ZM1 6V5C1 2.18716 3.23858 0 6 0C8.76142 0 11 2.18716 11 5V6H10.7181C11.1638 6 11.3255 6.04641 11.4884 6.13357C11.6514 6.22072 11.7793 6.34861 11.8664 6.51158C11.9536 6.67454 12 6.83618 12 7.28194V12.7181C12 13.1638 11.9536 13.3255 11.8664 13.4884C11.7793 13.6514 11.6514 13.7793 11.4884 13.8664C11.3255 13.9536 11.1638 14 10.7181 14H1.28194C0.836183 14 0.67454 13.9536 0.511577 13.8664C0.348614 13.7793 0.22072 13.6514 0.133566 13.4884C0.0464128 13.3255 0 13.1638 0 12.7181V7.28194C0 6.83618 0.0464128 6.67454 0.133566 6.51158C0.22072 6.34861 0.348614 6.22072 0.511577 6.13357C0.67454 6.04641 0.836183 6 1.28194 6H1ZM6 11C6.55228 11 7 10.5523 7 10C7 9.44771 6.55228 9 6 9C5.44772 9 5 9.44771 5 10C5 10.5523 5.44772 11 6 11Z",
		fill: "#F5A300"
	})]
});
const ForwardRef = forwardRef(SvgUnlock);
export { ForwardRef as ReactComponent };
